var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBottomNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V3L3.675 4.675L5.325 3L7 4.675L8.675 3L10.325 4.675L12 3L13.675 4.675L15.325 3L17 4.675L18.675 3L20.325 4.675L22 3V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H11V13H4V19ZM13 19H20V17H13V19ZM13 15H20V13H13V15ZM4 11H20V8H4V11Z",
    fill: "#B6BCC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottomNews);
export default __webpack_public_path__ + "static/media/icon_bottom_news.443575ca07ed15a8687b1ae1ae58cf16.svg";
export { ForwardRef as ReactComponent };